module.exports = __webpack_public_path__ + "static/media/mug-hot.e9beab72.svg";